import React, { Component } from "react";
// import banner from './../asset/images/banner.jpg';
// import logoRest from './../asset/images/logoRest.png';
import deletee from "./../asset/images/delete.svg";
import logo from "./../asset/images/sepandlogo.png";
import card from "./../asset/images/card.png";
import Back from "./../asset/images/back.svg";
import Tick from "./../asset/images/tick.svg";
import Cancel from "./../asset/images/cancel.svg";
import Phone from "./../asset/images/phoneblack.svg";
import Address from "./../asset/images/addressblack.svg";
import Email from "./../asset/images/email.png";
import Table from "./../asset/images/table.png";
import plus from "./../asset/images/plus.svg";
import minus from "./../asset/images/minus.svg";
import noimage from "./../asset/images/noimage.png";
import language from "./../asset/images/language.svg";
import profile from "./../asset/images/profile.svg";
import { Search } from "react-bootstrap-icons";
import Category from "./../components/Category";
import Group from "./../components/Group";
import Item from "./../components/Item";
import Login from "./../components/Login";
import Profile from "./../components/Profile";
import Language from "./../components/Language";
import { ImpulseSpinner } from "react-spinners-kit";
// import axios from "axios";
import ScrollContainer from "react-indiana-drag-scroll";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";
import CustomButton from "../components/CustomButton";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import { Form, Spinner } from "react-bootstrap";
import { word } from "../words.js";
import { Icon } from "@iconify/react";
import baselineAccessTime from "@iconify/icons-ic/baseline-access-time";
import cookingPotLight from "@iconify/icons-ph/cooking-pot-light";
import circleCheck from "@iconify/icons-akar-icons/circle-check";
import outlineCancel from "@iconify/icons-ic/outline-cancel";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export default class InvoiceInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      serverResponse: false,
      RestaurantName: "",
      RestaurantDes: "",
      RestaurantPhone: "",
      RestaurantAddress: "",
      RestaurantEmail: "",
      RestaurantLogo: null,
      RestaurantHeader: null,
      Menu: [],
      searchResult: [],
      searchValue: "",
      scrollIsBusy: false,
      priceUnit: "$",
      businessId: "",
      Orders: [],
      showOrderNotifi: false,
      itemCount: 0,
      showShoppingCard: false,
      ShoppingCard: [],
      totalPrice: 0,
      sumItem: 0,
      taxPrice: 0,
      servicePrice: 0,
      packingPrice: 0,
      discountPrice: 0,
      submitLoading: false,
      menuType: "",
      TableName: "",
      TableActive: false,
      fadeOverGradiantPercentLeft: "0",
      fadeOverGradiantPercentRight: "0",
      mobileValue: "",
      mobileError: "",
      mobileDisabled: false,
      userLangList: [],
      currentLang: {
        defaultLanguage: 1,
        direction: "rtl",
        flag: null,
        languageId: 1,
        tag: "fa",
        title: "فارسی",
      },
      defaultLangId: 0,
      currentLangIndex: 0,
      width: 0,
      ModalShow: false,
      modalContent: "",
      showProfile: false,
      businessInfo: null,
      tableNameIsEnglish: false,
      invoiceCalculating: false,
      hashId: "",
      invoiceInfo: null,
      invoiceId: "",
      desValue: "",
      prepareStatusTitle: "",
      statusTitle: "",
      logo: "",
      code: "",
      status: 0,
    };

    // this.categoryClick = this.categoryClick.bind(this);
    // this.scrollComplete = this.scrollComplete.bind(this);
    // this.calculateScroll = this.calculateScroll.bind(this);
    // this.updateTotalPrice = this.updateTotalPrice.bind(this);
    // this.calculateOrderCount = this.calculateOrderCount.bind(this);
    this.setCookie = this.setCookie.bind(this);
    this.getCookie = this.getCookie.bind(this);
    // this.mobileHandleChange = this.mobileHandleChange.bind(this);
    // this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    // this.getUserLanguageList = this.getUserLanguageList.bind(this);
    // this.getBusinessInfo = this.getBusinessInfo.bind(this);
    // this.setBusinessInfo = this.setBusinessInfo.bind(this);
    this.checkToken = this.checkToken.bind(this);
    // this.invoiceCalculator = this.invoiceCalculator.bind(this);
    this.container = React.createRef();
    // this.mobileInput = React.createRef();
  }

  componentDidMount() {
    // var url = new URL(window.location.href);
    // var data = url.searchParams.get("data");

    if (this.props.match.params.id) {
      this.checkToken();
    } else {
      //   this.props.history.push("/NotFound");
    }
  }

  checkToken() {
    var gomenu_user_mobile = this.getCookie("gomenu_user_mobile");
    var gomenu_user_token = this.getCookie("gomenu_user_token");
    // console.log(gomenu_user_mobile);
    // console.log(gomenu_user_token);
    if (gomenu_user_mobile && gomenu_user_token) {
      let data = {
        mobile: gomenu_user_mobile,
        token: gomenu_user_token,
      };

      fetch("https://api.sepandplus.ontco.com/publicapi/checkToken", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            this.setCookie("gomenu_user_mobile", gomenu_user_mobile, 30);
            this.setCookie("gomenu_user_token", gomenu_user_token, 30);
            this.setState({ ModalShow: false });
            this.getOrder();
          } else {
            document.cookie =
              "gomenu_user_mobile=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            document.cookie =
              "gomenu_user_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            this.setState({ ModalShow: true, serverResponse: true });
          }
        })
        .catch((err) => {
          document.cookie =
            "gomenu_user_mobile=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          document.cookie =
            "gomenu_user_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          this.setState({ ModalShow: true, serverResponse: true });
        });
    } else {
      document.cookie =
        "gomenu_user_mobile=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie =
        "gomenu_user_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      this.setState({ ModalShow: true, serverResponse: true });
    }
  }

  getUserLanguageList(code) {
    let data = {
      businessCode: code,
      token: "c305bf74-4cd9-41e9-b304-a5b94wsaq331c",
    };

    fetch(
      "https://api.sepandplus.ontco.com/publicapi/getBusinessLanguagesWithCode",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          let i = 0;
          result.result.forEach((element) => {
            if (element.defaultLanguage) {
              // console.log(element);
              this.setState(
                {
                  currentLang: element,
                  defaultLangId: element.languageId,
                  currentLangIndex: i,
                  priceUnit:
                    element.direction === "ltr"
                      ? this.state.invoiceInfo.priceUnitLTR
                      : this.state.invoiceInfo.priceUnitRTL,
                },
                () => {
                  this.setState({ userLangList: result.result }, () => {
                    let items = this.state.invoiceInfo.items;
                    let resname = "";

                    for (
                      let i = 0;
                      i < this.state.invoiceInfo.businessNameObj.length;
                      i++
                    ) {
                      if (
                        this.state.currentLang.languageId ===
                        this.state.invoiceInfo.businessNameObj[i].languageId
                      ) {
                        resname =
                          this.state.invoiceInfo.businessNameObj[i].name;
                      }
                    }
                    if (!resname)
                      resname = this.state.invoiceInfo.businessNameObj[0].name;
                    this.setState({
                      RestaurantName: resname,
                      Orders: items,
                      serverResponse: true,
                    });
                    return;
                  });
                }
              );
            }
            i++;
          });
        } else {
          if (
            this.props.match.params.code.toString().toLowerCase() !==
            "factureinfo"
          ) {
            this.props.history.push("/NotFound");
          }
        }
      })
      .catch((err) => {});
  }

  getOrder() {
    let data = {
      mobile: this.getCookie("gomenu_user_mobile"),
      token: this.getCookie("gomenu_user_token"),
      hashId: this.props.match.params.id,
    };

    this.setState({ serverResponse: false });

    fetch("https://api.sepandplus.ontco.com/publicapi/findOneForCustomer", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          console.log(result);

          this.setState(
            {
              invoiceInfo: result.result[0],
              invoiceId: result.result[0].id,
              sumItem: result.result[0].sumItem,
              taxPrice: result.result[0].tax,
              servicePrice: result.result[0].service,
              packingPrice: result.result[0].packing,
              discountPrice: result.result[0].discount,
              totalPrice: result.result[0].sum,
              desValue: result.result[0].descr,
              prepareStatusTitle: result.result[0].prepareStatusTitle,
              statusTitle: result.result[0].statusTitle,
              status: result.result[0].status,
              logo: result.result[0].logo,
              code: result.result[0].code,
            },
            () => {
              this.getUserLanguageList(result.result[0].code);
            }
          );
        }
      })
      .catch((err) => {});
  }

  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  onLoginClick(mobile, token) {
    this.setState(
      {
        ModalShow: false,
      },
      () => {
        this.setCookie("gomenu_user_mobile", mobile, 30);
        this.setCookie("gomenu_user_token", token, 30);
        this.getOrder();
      }
    );
  }

  onLogoutClick() {
    document.cookie =
      "gomenu_user_mobile=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      "gomenu_user_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    this.setState({ modalContent: "", ModalShow: false, showProfile: false });
  }

  onBack() {
    // console.log(this.props.location.state);
    // return;
    this.props.history.push({
      pathname: "/" + this.props.location.state.backURL,
      state: { showHistory: this.props.location.state.showHistory },
    });
  }

  onLogoClick() {
    this.props.history.push({
      pathname: "/" + this.state.code,
      state: { showHistory: false },
    });
  }

  render() {
    if (this.state.serverResponse) {
      if (!this.state.ModalShow) {
        return (
          <div
            className={
              this.state.currentLang.direction === "rtl"
                ? "Login rtlStyle IRANSansMobileFont"
                : "Login ltrStyle SFUIDisplayFont"
            }
          >
            <div className="header">
              {this.props.location.state && (
                <div
                  onClick={this.onBack.bind(this)}
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "linkStyle backButton IRANSansMobileBoldFont"
                      : "linkStyle backButton SFUIDisplayBoldFont"
                  }
                >
                  <img
                    src={Back}
                    alt=""
                    className="backButtonIcon"
                    style={{
                      transform:
                        this.state.currentLang.direction === "rtl"
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                    }}
                  />
                  {word[this.state.currentLang.tag]["back"]}
                </div>
              )}
            </div>
            <div className="LoginContent">
              <div
                className="invoiceOrderLogo"
                style={{ cursor: "pointer" }}
                onClick={this.onLogoClick.bind(this)}
              >
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  src={
                    "https://api.sepandplus.ontco.com/api/public/" +
                    this.state.logo
                  }
                  alt=""
                />
              </div>
              <div
                className={
                  this.state.currentLang.direction === "rtl"
                    ? "RestaurantsListTitle IRANSansMobileBoldFont"
                    : "RestaurantsListTitle SFUIDisplayBoldFont"
                }
              >
                {this.state.RestaurantName}
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  maxWidth: "768px",
                }}
                className={
                  this.state.currentLang.direction === "rtl"
                    ? "RestaurantsListSubTitle IRANSansMobileBoldFont"
                    : "RestaurantsListSubTitle SFUIDisplayBoldFont"
                }
              >
                <div
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "RestaurantsListSubTitle IRANSansMobileBoldFont"
                      : "RestaurantsListSubTitle SFUIDisplayBoldFont"
                  }
                >
                  {word[this.state.currentLang.tag]["facNumber"]}&nbsp;
                  {this.state.invoiceId}
                </div>

                {(this.state.prepareStatusTitle || this.state.statusTitle) && (
                  <div
                    style={{
                      border:
                        this.state.status !== 4 && this.state.status !== 5
                          ? "2px solid var(--brown1)"
                          : "2px solid var(--red1)",
                      borderRadius: "25px",
                      color:
                        this.state.status !== 4 && this.state.status !== 5
                          ? "var(--brown1)"
                          : "var(--red1)",
                      backgroundColor:
                        this.state.status !== 4 && this.state.status !== 5
                          ? "#ce835142"
                          : "#f73b4142",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      gap: "4px",
                      fontSize: "12px",
                    }}
                    className="prepareStatus"
                  >
                    <Icon
                      icon={
                        this.state.status === 1
                          ? baselineAccessTime
                          : this.state.status === 2
                          ? circleCheck
                          : this.state.status === 4 || this.state.status === 5
                          ? outlineCancel
                          : this.state.status === 6
                          ? baselineAccessTime
                          : cookingPotLight
                      }
                      width="24"
                      height="24"
                    />
                    {this.state.status !== 3
                      ? this.state.statusTitle
                      : this.state.prepareStatusTitle}
                  </div>
                )}
              </div>

              <div className="editableOrderListContainer">
                {this.state.Orders.map((item, i) => {
                  if (item.quantity > 0) {
                    return (
                      <div
                        key={i}
                        style={{
                          width: "100%",
                          maxWidth: "768px",
                          backgroundColor: "white",
                          padding: "10px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          marginBottom: "10px",
                          direction: this.state.currentLang.direction,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div className="foodItemSmallTitle">
                            {item.foodName}
                          </div>
                          <div
                            style={{
                              flex: "1",
                              minWidth: "20px",
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <div className="foodItemSmallTitle">
                              {item.quantity}
                            </div>
                            <div
                              style={{
                                height: "30px",
                                minWidth: "1px",
                                backgroundColor: "var(--gray3)",
                                margin: "0px 15px",
                              }}
                            />
                            <div
                              style={{
                                fontFamily:
                                  this.state.currentLang.direction === "rtl"
                                    ? "IRANSansMobileBold"
                                    : "SFUIDisplayBold",
                                color: "var(--green1)",
                                fontSize: "14px",
                              }}
                            >
                              <NumericFormat
                                allowNegative={true}
                                value={item.price}
                                displayType={"text"}
                                thousandSeparator={true}
                              />
                              &nbsp;{this.state.priceUnit}
                            </div>
                          </div>
                        </div>
                        {/* <div
                          style={{
                            width: "100%",
                            minHeight: "1px",
                            backgroundColor: "var(--gray3)",
                            margin: "5px 0px",
                          }}
                        />

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontFamily:
                              this.state.currentLang.direction === "rtl"
                                ? "IRANSansMobileBold"
                                : "SFUIDisplayBold",
                            color: "var(--green1)",
                          }}
                        >
                          <div />
                          <div>
                            <NumericFormat
                              allowNegative={true}
                              value={item.price}
                              displayType={"text"}
                              thousandSeparator={true}
                            />
                            &nbsp;{this.state.priceUnit}
                          </div>
                        </div> */}
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
              </div>

              <div
                style={{
                  width: "100%",
                  height: "1px",
                  backgroundColor: "var(--gray3)",
                  maxWidth: "768px",
                  margin: "10px 0px",
                }}
              />
              {this.state.desValue && (
                <div
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "var(--gray1)",
                    maxWidth: "768px",
                    width: "100%",
                    padding: "7px",
                    color: "white",
                    marginBottom: "20px",
                    textAlign: "start",
                    unicodeBidi: "plaintext",
                  }}
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "rtlStyle IRANSansMobileFont"
                      : "ltrStyle SFUIDisplayFont"
                  }
                >
                  {this.state.desValue}
                </div>
              )}
              <div
                className={
                  this.state.currentLang.direction === "rtl"
                    ? "editablePriceContainer IRANSansMobileFont"
                    : "editablePriceContainer SFUIDisplayFont"
                }
              >
                <div>{word[this.state.currentLang.tag]["total"]}</div>
                {!this.state.invoiceCalculating && (
                  <div>
                    <NumericFormat
                      allowNegative={true}
                      value={this.state.sumItem}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                    &nbsp;{this.state.priceUnit}
                  </div>
                )}

                {this.state.invoiceCalculating && (
                  <div>
                    <ImpulseSpinner
                      size={25}
                      frontColor="var(--black1)"
                      backColor="var(--gray1)"
                      loading={true}
                    />
                  </div>
                )}
              </div>

              {this.state.taxPrice > 0 && (
                <div
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "editablePriceContainer IRANSansMobileFont"
                      : "editablePriceContainer SFUIDisplayFont"
                  }
                >
                  <div>{word[this.state.currentLang.tag]["tax"]}</div>
                  {!this.state.invoiceCalculating && (
                    <div>
                      <NumericFormat
                        allowNegative={true}
                        value={this.state.taxPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                      &nbsp;{this.state.priceUnit}
                    </div>
                  )}

                  {this.state.invoiceCalculating && (
                    <div>
                      <ImpulseSpinner
                        size={25}
                        frontColor="var(--black1)"
                        backColor="var(--gray1)"
                        loading={true}
                      />
                    </div>
                  )}
                </div>
              )}

              {this.state.servicePrice > 0 && (
                <div
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "editablePriceContainer IRANSansMobileFont"
                      : "editablePriceContainer SFUIDisplayFont"
                  }
                >
                  <div>{word[this.state.currentLang.tag]["services"]}</div>
                  {!this.state.invoiceCalculating && (
                    <div>
                      <NumericFormat
                        allowNegative={true}
                        value={this.state.servicePrice}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                      &nbsp;{this.state.priceUnit}
                    </div>
                  )}

                  {this.state.invoiceCalculating && (
                    <div>
                      <ImpulseSpinner
                        size={25}
                        frontColor="var(--black1)"
                        backColor="var(--gray1)"
                        loading={true}
                      />
                    </div>
                  )}
                </div>
              )}

              {this.state.packingPrice > 0 && (
                <div
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "editablePriceContainer IRANSansMobileFont"
                      : "editablePriceContainer SFUIDisplayFont"
                  }
                >
                  <div>{word[this.state.currentLang.tag]["packing"]}</div>
                  {!this.state.invoiceCalculating && (
                    <div>
                      <NumericFormat
                        allowNegative={true}
                        value={this.state.packingPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                      &nbsp;{this.state.priceUnit}
                    </div>
                  )}

                  {this.state.invoiceCalculating && (
                    <div>
                      <ImpulseSpinner
                        size={25}
                        frontColor="var(--black1)"
                        backColor="var(--gray1)"
                        loading={true}
                      />
                    </div>
                  )}
                </div>
              )}

              {this.state.discountPrice > 0 && (
                <div
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "editablePriceContainer IRANSansMobileFont"
                      : "editablePriceContainer SFUIDisplayFont"
                  }
                >
                  <div>{word[this.state.currentLang.tag]["discount"]}</div>
                  {!this.state.invoiceCalculating && (
                    <div>
                      <NumericFormat
                        allowNegative={true}
                        value={this.state.discountPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                      &nbsp;{this.state.priceUnit}
                    </div>
                  )}

                  {this.state.invoiceCalculating && (
                    <div>
                      <ImpulseSpinner
                        size={25}
                        frontColor="var(--black1)"
                        backColor="var(--gray1)"
                        loading={true}
                      />
                    </div>
                  )}
                </div>
              )}

              <div
                style={{
                  width: "100%",
                  minHeight: "1px",
                  backgroundColor: "var(--gray3)",
                  margin: "8px 0px",
                  maxWidth: "768px",
                }}
              />

              <div
                className={
                  this.state.currentLang.direction === "rtl"
                    ? "editableTotalContainer IRANSansMobileBoldFont"
                    : "editableTotalContainer SFUIDisplayBoldFont"
                }
                style={{ marginTop: "10px" }}
              >
                <div>{word[this.state.currentLang.tag]["totalPrice"]}</div>
                {!this.state.invoiceCalculating && (
                  <div>
                    <NumericFormat
                      allowNegative={true}
                      value={this.state.totalPrice}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                    &nbsp;{this.state.priceUnit}
                  </div>
                )}

                {this.state.invoiceCalculating && (
                  <div>
                    <ImpulseSpinner
                      size={35}
                      frontColor="var(--black1)"
                      backColor="var(--gray1)"
                      loading={true}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <Modal
            size="sm"
            show={this.state.ModalShow}
            animation={false}
            onHide={this.hideModal.bind(this)}
            centered
          >
            <Login
              currentLang={this.state.currentLang}
              onLoginClick={this.onLoginClick.bind(this)}
              onCancel={this.hideModal.bind(this)}
            />
          </Modal>
        );
      }
    } else {
      return (
        <div className="loadingStyle">
          <ImpulseSpinner
            size={50}
            frontColor="var(--brown1)"
            backColor="var(--gray1)"
            loading={true}
          />
        </div>
      );
    }
  }
}
